import log from 'loglevel';
import { ApiService } from "./ApiService";
import { ApiEndpoints } from '@/constants/ApiEndpoints';





import { Paging } from "@/interfaces/Paging";
import { createUser } from "@/interfaces/User";
import { VerifyOTPParams } from "@/interfaces/InHouseTasks/VerifyOTPParams";
import { TokenRequiredStrategy } from "../strategies/TokenRequiredStrategy";
import { VerifyOTPResponse } from "@/interfaces/InHouseTasks/VerifyOTPResponse";
import { ResendOTPResponse } from "@/interfaces/InHouseTasks/ResendOTPResponse";
import { EarnDataAPIResponse } from "@/interfaces/InHouseTasks/EarnDataAPIResponse";
import { InHouseTaskTaskData } from "@/interfaces/InHouseTasks/InhouseTaskTaskData";
import { InHouseTasks, createInHouseTask } from "@/interfaces/InHouseTasks/InHouseTasks";
import { VerifyPhoneNumberInput } from "@/interfaces/InHouseTasks/VerifyPhoneNumberInput";
import { VerifyPhoneNumberResponse } from "@/interfaces/InHouseTasks/VerifyPhoneNumberResponse";
import { createVerifyPhoneNumberInHouseTask } from "@/interfaces/InHouseTasks/VerifyPhoneNumberInHouseTask";





class InHouseTasksServiceClass extends ApiService {


  private EARD_DATA_ENDPOINT = ApiEndpoints.EARN_DATA;
  private EARN_OPTION_ENDPOINT = ApiEndpoints.EARN_OPTIONS;
  private RESEND_OTP_ENDPOINT = ApiEndpoints.RESEND_OTP;
  private PHONE_VERIFICATION_ENDPOINT = ApiEndpoints.PHONE_VERIFICATION;
  private OTP_VERIFICATION_ENDPOINT = ApiEndpoints.OTP_VERIFICATION;





  constructor() {
    super(TokenRequiredStrategy);
  }




  async getInHouseTasks(): Promise<Record<string, InHouseTasks>> {
    try {
      const response = await this.get(this.EARN_OPTION_ENDPOINT, { platforms: 8 });
      const inHouseTasks: Record<string, InHouseTasks> = {};

      response.in_house_tasks.forEach((taskData: InHouseTaskTaskData) => {
        let task: InHouseTasks;
        if (taskData.name === "Verify Your Phone") {
          task = createVerifyPhoneNumberInHouseTask(taskData);
        } else {
          task = createInHouseTask(taskData);
        }
        inHouseTasks[task.name] = task;
      });

      return inHouseTasks;
    } catch (error) {
      log.error("Failed to get in-house tasks:", error);
      throw error;
    }
  }






  async claimDailyCheckin(): Promise<InHouseTasks> {
    try {
      const response = await this.post(`${this.EARN_OPTION_ENDPOINT}/1`);
      return response;
    } catch (error) {
      log.error("Failed to claim daily check-in:", error);
      throw error;
    }
  }






  
  async verifyPhoneNumber(
    input: VerifyPhoneNumberInput
  ): Promise<VerifyPhoneNumberResponse> {
    try {
      const response: VerifyPhoneNumberResponse = await this.post(
        this.PHONE_VERIFICATION_ENDPOINT,
        input,
      );
      // if (!response.sms_sent) throw new Error("SMS not sent");
      return response;
    } catch (error) {
			log.error("Error in verifyPhoneNumber:", error);
      throw error;
    }
  }







  
  async verifyOTP(input: VerifyOTPParams): Promise<VerifyOTPResponse> {
    try {
      const response = await this.post(this.OTP_VERIFICATION_ENDPOINT, input);
      return {
        user: createUser(response.user),
        success: response.success,
      };
    } catch (error) {
      log.error("Error in verifyOTP:", error);
      throw error;
    }
  }



  async resendOTP(): Promise<ResendOTPResponse> {
    try {
      const response: ResendOTPResponse = await this.post(this.RESEND_OTP_ENDPOINT, { is_resend: true });
      return response;
    }
    catch (error) {
      log.error("Error in resending OTP", error);
      throw error;
    }
  }


	




  async getEarnData(paging: Paging): Promise<EarnDataAPIResponse> {
    try {
      const response = await this.get(this.EARD_DATA_ENDPOINT, paging);
      return response;
    } catch (error) {
      log.error("Error in getEarnData:", error);
      throw error;
    }
  }









  async claimInHouseTaskById(
    id: number,
    params: object
  ): Promise<InHouseTasks> {
    try {

      
      const response = await this.post(
        `${this.EARN_OPTION_ENDPOINT}/${id}`,
        params
      );
      return response;


    } catch (error) {
      log.error("Failed to claim in-house task:", error);
      throw error;
    }
  }
}

// Create an instance of the class and export it
const InHouseTasksService = new InHouseTasksServiceClass();
export { InHouseTasksService };
